import { select } from 'redux-saga/effects';
import { getEnv, getRequestWhitelistCookiesString } from 'selectors';
import { ApiRequestConfig } from './api';

export function buildUrl(base: string, part: string) {
	return new URL(part, base).toString();
}

export function* getApiParams(path: string, config: ApiRequestConfig = {}) {
	const { ORCHESTRATOR_HOST, USE_CREDENTIALS, requestID, apiKey } = (yield select(
		getEnv
	)) as ReturnType<typeof getEnv>;
	config.withCredentials = USE_CREDENTIALS;

	if (__IS_SERVER__) {
		const cookie: string = yield select(getRequestWhitelistCookiesString);
		config.headers = USE_CREDENTIALS ? { ...config.headers, Cookie: cookie } : config.headers;
	}

	if (requestID) {
		config.headers = { ...config.headers, 'x-request-id': requestID };
	}

	if (apiKey) {
		config.headers = { ...config.headers, 'x-api-key': config.headers['x-api-key'] || apiKey };
	}

	const url = buildUrl(config.url || ORCHESTRATOR_HOST, path);

	return { url, config };
}
